import { Title } from '@mantine/core';
import { BaseLayout, Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { WallFormingBaseRoute } from 'app/modules/routePaths';
import { PlanToIfcWorkspace } from 'app/modules/wallforming/components/plan-to-ifc/PlanToIfcWorkspace';

/** Standalone entry: create an IFC model from plans before opening the wall assistant. */
export const PlanStartPage = () => {
    const { t } = useTranslation();

    return (
        <BaseLayout
            className="bg-background-gray-ultra-ultra-light"
            environment={import.meta.env.VITE_ENVIRONMENT}
            innerClassName="h-full w-full overflow-auto p-6"
            versionNumber={APP_VERSION}
            withCookieBanner={false}
        >
            <div className="mx-auto w-full max-w-[44rem] space-y-4" data-testid="plan-start-page">
                <div className="flex items-end justify-between gap-4">
                    <div>
                        <Title order={3}>{t('titlePlanStart')}</Title>
                        <div className="mt-1 text-sm text-text-light">{t('infoPlanStart')}</div>
                    </div>
                    <Link
                        className="flex shrink-0 items-center gap-1 text-sm underline"
                        to={`/${WallFormingBaseRoute}`}
                    >
                        {t('buttonOpenWallFormingWithoutModel')}
                        <Icon icon="arrow_forward" size="sm" />
                    </Link>
                </div>
                <div className="rounded-md border border-border-light bg-background-default p-4 shadow-sm">
                    <PlanToIfcWorkspace />
                </div>
            </div>
        </BaseLayout>
    );
};
